import {
  IdCard,
  FileText,
  StickyNote,
  BookOpen,
  Folder,
  LayoutPanelTop,
  Copy,
  ClipboardList,
  PenLine,
  Package,
  type LucideIcon,
} from "lucide-react";

// Maps the catalogue item's icon name (a stable string in mock data / the
// future catalogue model) to a concrete lucide icon. Binding a component is a
// shell concern, so it lives here rather than in shared-core.
const ICON_BY_NAME: Record<string, LucideIcon> = {
  "id-badge-2": IdCard,
  "file-text": FileText,
  note: StickyNote,
  book: BookOpen,
  folder: Folder,
  "layout-board": LayoutPanelTop,
  copy: Copy,
  "clipboard-text": ClipboardList,
  pencil: PenLine,
};

export function catalogueIcon(name: string | undefined): LucideIcon {
  return (name && ICON_BY_NAME[name]) || Package;
}
